import { createState } from '~/src/hooks/useEoState'
import { AppState } from '@capacitor/app'

export const APP_STATE = createState<AppState>({
  key: 'appState',
  default: {
    isActive: false
  }
})
